/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Gl_13_TInputs */

const en_tut_gl_13_t = /** @type {(inputs: Tut_Gl_13_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area conversation`)
};

const id_tut_gl_13_t = /** @type {(inputs: Tut_Gl_13_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percakapan area`)
};

/**
* | output |
* | --- |
* | "Area conversation" |
*
* @param {Tut_Gl_13_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_gl_13_t = /** @type {((inputs?: Tut_Gl_13_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Gl_13_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_gl_13_t(inputs)
	return en_tut_gl_13_t(inputs)
});